import { createAction, ActionsUnion } from "../definitions";
import { TranslationActionTypes } from "./types";

export interface ITranslationPayload {
    language?: string;
    sentenceDirectory?: { [key: string]: string };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TranslationActions = {
    /**
     * Action will set translations, by merging the provided sentence directory with the existing one.
     *
     * @param {ITranslationPayload} payload - Object containing the sentenceDirectory to be set.
     */
    setTranslations: (payload: ITranslationPayload) => createAction(TranslationActionTypes.SET_TRANSLATIONS, payload),

    /**
     * Action creator clear translations and set the language to either the provided language or to "en"
     *
     * @param {ITranslationPayload} payload - Object containing the language to be set.
     */
    clearTranslations: (payload: ITranslationPayload) => createAction(TranslationActionTypes.CLEAR_TRANSLATIONS, payload)
};


// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TranslationActions = ActionsUnion<typeof TranslationActions>;